const intersection = require('lodash/intersection');

window.addEventListener('alpine:init', bootstrap);

export default function() {
	return {
		content: [],
		show_content: false,
		filtered_content: [],
		filter_keys: [ 'industries', 'topics' ],
		filter_criteria: { },
		show_count: this.$persist(0).using(sessionStorage),
		max_show_count: 1,
		active_index: 0,
		init() {
			try {
				const content_text = this.$refs?.content?.textContent;
				if ( content_text ) { this.content = JSON.parse(content_text); }
			} catch (error) {
				console.error(`Can't parse content data: `, error); // eslint-disable-line no-console
			}
		},
		showContentCallback() {
			if ( this.show_count >= this.max_show_count ) {
				this.$dispatch('show-opportunity-modal', { source: 'insights' });
				return;
			}
			this.show_count++;
			this.show_content = true;
			this.$dispatch('opportunity-content-button-active', false);
		},
		get has_next() {
			return this.active_index + 1 < this.filtered_content.length;
		},
		next() {
			// Don't go over bounds
			if ( !this.has_next ) { return; }

			this.active_index++;
		},
		get has_prev() {
			return this.active_index > 0;
		},
		previous() {
			// Don't go over bounds
			if ( !this.has_prev ) { return; }

			this.active_index--;
		},
		filter() {
			const key = this.$event.detail.key;
			if ( !this.filter_keys.includes(key) ) { return; }

			this.show_content = false;

			const value = this.$event.detail.value;
			const delete_filter_criteria_key = typeof value === 'object'
				? value.length === 0
				: value == ''
			;
			if ( delete_filter_criteria_key ) {
				delete this.filter_criteria[key];
			} else {
				this.filter_criteria[key] = value;
			}

			if ( Object.keys(this.filter_criteria).length >= 2 ) {
				this.$dispatch('opportunity-content-button-active', true);
				this.filtered_content = this.applyFilterCriteria();
			} else {
				this.$dispatch('opportunity-content-button-active', false);
			}

		},
		applyFilterCriteria() {
			let content = this.content;

			(Object.keys(this.filter_criteria)).forEach(key => {
				const value = this.filter_criteria[key];
				if ( typeof value === 'object' ) {
					content = content.filter(_ => intersection(_[key], value).length > 0 );
				} else {
					content = content.filter(_ => _[key].includes(value));
				}
			});

			return content;
		}
	};
}

function bootstrap() {
	document.querySelectorAll('.js-opportunity-content-button').forEach(
		$$ => bootstrapButton($$)
	);
}

function bootstrapButton($el) {
	$el.setAttribute('x-data', '{ active: false }');
	$el.setAttribute('x-on:click.prevent', `$dispatch("show-opportunity-content")`);
	$el.setAttribute('x-on:opportunity-content-button-active.window', 'active = $event.detail');
	$el.setAttribute(':class', '{ "is-inactive": !active }');
}
